/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { Maybe } from '@codegrade/maybe';
import { getStoreBuilder } from '@codegrade/vuex-typex';
import * as utils from '@/utils';
const storeBuilder = getStoreBuilder();
const moduleBuilder = storeBuilder.module('submission_order', {
    data: Maybe.empty(),
});
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export var SubmissionOrderStore;
(function (SubmissionOrderStore) {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    SubmissionOrderStore.commitOrder = moduleBuilder.commit((state, 
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    payload) => {
        state.data = Maybe.of({
            assignmentId: payload.assignmentId,
            userIds: payload.submissions.map(utils.attr('userId')),
        });
    }, 'setSubmissionIds');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    SubmissionOrderStore.commitClearAll = moduleBuilder.commit(state => {
        state.data = Maybe.empty();
    }, 'commitClearAll');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    SubmissionOrderStore.sortSubmissions = moduleBuilder.read(state => 
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    (payload) => {
        const lookup = utils.makeLookupMapping(payload.submissions, 'userId');
        return state.data
            .filter(x => x.assignmentId === payload.assignmentId)
            .map(x => x.userIds.map(utils.getItem(lookup)))
            .map(Maybe.catMaybes);
    }, 'submissionIds');
    utils.signal.AFTER_USER_CHANGED.register(async () => {
        SubmissionOrderStore.commitClearAll();
    });
})(SubmissionOrderStore || (SubmissionOrderStore = {}));
